class StudyQueryKeys {
  private prefix = 'study';

  getStudy(studyId: string) {
    return [this.prefix, studyId];
  }
}

export default StudyQueryKeys;
